var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0685 7.64014L17.5444 0.865234H16.0098L10.3868 6.74779L5.89574 0.865234H0.71582L7.5072 9.7607L0.71582 16.8652H2.25048L8.18851 10.6531L12.9314 16.8652H18.1113L11.0681 7.64014H11.0685ZM8.96658 9.83907L8.27848 8.95329L2.80344 1.90497H5.16059L9.57901 7.59319L10.2671 8.47898L16.0105 15.8728H13.6534L8.96658 9.83941V9.83907Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.1a64d5fa18533b49e75242e9f11dc8c1.svg";
export { ForwardRef as ReactComponent };